import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiChevronRight, FiFolder, FiMoreVertical } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import documentsPhoto from '../../../images/home/documents-photo.png';

const FOLDERS = [
  { name: 'Contracts', count: '12 files' },
  { name: 'Proposals', count: '8 files' },
  { name: 'Reports', count: '15 files' },
  { name: 'HR', count: '6 files' },
];

const FILES = [
  { name: 'Q4_Proposal.pdf', meta: '2.4 MB · 2h ago', type: 'pdf', mark: 'PDF' },
  { name: 'Project_Brief.docx', meta: '1.1 MB · 1d ago', type: 'doc', mark: 'W' },
  { name: 'Budget_2024.xlsx', meta: '950 KB · 2d ago', type: 'xls', mark: 'X' },
  { name: 'Meeting_Notes.pdf', meta: '1.6 MB · 3d ago', type: 'pdf', mark: 'PDF' },
];

const HomeDocumentsVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-docs-stage">
      <div className="home-docs-photo-wrap">
        <motion.img
          src={documentsPhoto}
          alt="Professional reviewing a document at his desk"
          className="home-docs-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--docs-panel"
        cardClassName="home-float-card--docs-panel"
        enterDelay={0.22}
        inView
        drift={{ x: 4, y: -10, duration: 5.4, durationX: 6.8 }}
      >
        <header className="home-docs-panel-head">
          <span className="home-docs-panel-icon">
            <FiFolder />
          </span>
          <strong>Documents</strong>
          <FiMoreVertical />
        </header>

        <p className="home-docs-label">Folders</p>
        <ul className="home-docs-folders">
          {FOLDERS.map((folder, index) => (
            <motion.li
              key={folder.name}
              initial={reduce ? false : { opacity: 0, x: -8 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: 0.28 + index * 0.07, ease: HOME_EASE }}
            >
              <span className="home-docs-folder-icon">
                <FiFolder />
              </span>
              <strong>{folder.name}</strong>
              <small>{folder.count}</small>
            </motion.li>
          ))}
        </ul>

        <p className="home-docs-label">Recent Files</p>
        <ul className="home-docs-files">
          {FILES.map((file, index) => (
            <motion.li
              key={file.name}
              initial={reduce ? false : { opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.42 + index * 0.08, ease: HOME_EASE }}
            >
              <span className={`home-docs-file-icon is-${file.type}`}>{file.mark}</span>
              <div>
                <strong>{file.name}</strong>
                <small>{file.meta}</small>
              </div>
            </motion.li>
          ))}
        </ul>

        <p className="home-docs-view">
          View all files
          <FiChevronRight />
        </p>

        <div className="home-docs-storage">
          <div className="home-docs-storage-row">
            <span>Storage Usage</span>
            <strong>37%</strong>
          </div>
          <p>7.4 GB of 20 GB used</p>
          <span className="home-docs-storage-track">
            <motion.i
              initial={reduce ? false : { width: 0 }}
              whileInView={{ width: '37%' }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.8, delay: 0.55, ease: HOME_EASE }}
            />
          </span>
        </div>
      </HomeFloat>
    </div>
  );
};

export default HomeDocumentsVisual;
